import NavBar from "./Components/NavBar";
import "./CSS/registrarZonaParrilla.css";
import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  where,
  deleteDoc,
  doc,
  orderBy,
} from "firebase/firestore";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { db } from "./FirebaseConfig/firebase";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { addDoc, updateDoc } from "firebase/firestore";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import axios from 'axios';

import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import LinearProgress from "@mui/material/LinearProgress";
import ContactMailRoundedIcon from "@mui/icons-material/ContactMailRounded";
import PasswordRoundedIcon from "@mui/icons-material/PasswordRounded";
import boleta from "./img/boleta.png";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const MySwal = withReactContent(Swal);
function RegistrarZonaParrilla() {
  const navigate = useNavigate();
  const { id } = useParams();

  //datos del usuario principal
  const [nombreUsuario, setNombreUsuario] = React.useState("");
  const [apellidoUsuario, setApellidoUsuario] = React.useState("");
  const [idUsuario, setIdUsuario] = React.useState("");
  const [CIP, setCIP] = React.useState(localStorage.getItem("idLocal"));
  const [cipBuscado, setCipBuscado] = useState("");
  const [nombreIngenieroBuscado, setNombreIngenieroBuscado] = useState("");
  const [idRefBuscado, setIdRefBuscado] = useState("0");

  const [invitadosList, setInvitadosList] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  const [idReservaParrilla, setIdReservaParrilla] = useState("");

  const [nombreyapellido, setNombreyapellido] = useState("");
  const [dni, setDni] = useState("");
  const [fecha, setFecha] = useState(localStorage.getItem("fechaParrilla"));
  const [nombreyapellidovisible, setNombreyapellidovisible] = useState(false);
  const [costoTotal, setCostoTotal] = useState(0);

  const [fechaFormateada, setFechaFormateada] = useState(
    localStorage.getItem("fechaParrilla")
  );

  const [capacidad, setCapacidad] = useState(20);
  const [categoriaEdad, setCategoriaEdad] = useState("Adulto");

  const [nombreUsuarioReservado, setNombreUsuarioReservado] = useState("");
  const [cipUsuarioReservado, setCipUsuarioReservado] = useState("");
  const [idRegistroReservado, setIdRegistroReservado] = useState("");
  const [idRefUsuarioReservado, setIdRefRegistroReservado] = useState("");

  const [editarReserva, setEditarReserva] = useState(false);
  const [pbVisibleBusqueda, setpbVisibleBusqueda] = useState(false);

  const [nroSerie, setNroSerie] = React.useState("");
  const [correlativo, setCorrelativo] = React.useState("");
  const [monto, setMonto] = React.useState(0);
  const [pbVisible, setpbVisible] = React.useState(false);
  const [esPago, setEsPago] = React.useState(false);
  const [mostrarPago, setMostrarPago] = React.useState(false);
  const [pagosDiferidos, setPagosDiferidos] = useState([]);
  const [observaciones, setObservaciones] = useState("");
  let temporalObservaciones = "";

  const buscarUsuarioCip = async () => {
    let usuarioEncontrado = false;
    const q = query(collection(db, "USUARIOS"), where("cip", "==", CIP));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      usuarioEncontrado = true;
      setIdUsuario(doc.id);
      setNombreUsuario(doc.data().nombre);
      setApellidoUsuario(doc.data().apellidos);
    });
  };

  const buscarCodigoCip = async () => {
    if (cipBuscado == "") {
      MySwal.fire("", "Ingrese el CIP a buscar", "error");
    } else {
      setpbVisibleBusqueda(true);
      let usuarioEncontrado = false;

      const q = query(
        collection(db, "USUARIOS"),
        where("cip", "==", cipBuscado)
      );
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        usuarioEncontrado = true;

        setIdUsuario(doc.id);
        //buscarIdAsientoUser();
        setNombreIngenieroBuscado(
          doc.data().nombre + " " + doc.data().apellidos
        );
        setCIP(doc.data().cip);
        setIdRefBuscado(doc.id);
        //setCIP(doc.id);
        setNombreUsuario(doc.data().nombre);
        setApellidoUsuario(doc.data().apellidos);
        setpbVisibleBusqueda(false);
        setNombreyapellidovisible(true);
      });
      if (usuarioEncontrado == false) {
        const res = await axios.get(
          `https://reservas.ciparequipa.org.pe/colegiados/${cipBuscado}`
        );
        if (res.data.length != 0) {
          const dbusuario = collection(db, `USUARIOS`);
          await addDoc(dbusuario, {
            apellidos: res.data[0].vapecol,
            nombre: res.data[0].vnomcol,
            cip: res.data[0].ncodcol.toString(),
            dni: res.data[0].ndnicol,
            nivel: "ingeniero",
          }).then(async (docRef) => {
            setIdUsuario(docRef.id);
            //buscarIdAsientoUser();
            setNombreUsuario(res.data[0].vnomcol);
            setApellidoUsuario(res.data[0].vapecol);
            setpbVisibleBusqueda(false);
          });
        } else {
          setpbVisibleBusqueda(false);
          MySwal.fire("", "CIP NO ENCONTRADO", "error");
          setCipBuscado("");
        }
      }
    }
  };
  const elementos = [
    {
      nombre: "ZONA 1",
      id: "zona1",
    },
    {
      nombre: "ZONA 2",
      id: "zona2",
    },
    {
      nombre: "ZONA 3",
      id: "zona3",
    },
    {
      nombre: "ZONA 4",
      id: "zona4",
    },
    {
      nombre: "ZONA 5",
      id: "zona5",
    },
    {
      nombre: "ZONA 6",
      id: "zona6",
    },
    {
      nombre: "CAJA CHINA 1",
      id: "caja1",
    },
    {
      nombre: "CAJA CHINA 2",
      id: "caja2",
    },
  ];

  //Funcion para agregar invitados a la tabla
  const agregarInvitado = () => {
    if (nombreyapellido == "" || dni == "") {
      Swal.fire({
        position: "center",
        title: `Llene los datos del invitado`,

        icon: "error",
        showConfirmButton: false,
        timer: 1000,
      });
    } else {
      if (dni.length < 8 || dni.length > 10) {
        Swal.fire({
          position: "center",
          title: `INGRESE DNI VÁLIDO`,
          icon: "error",
          showConfirmButton: false,
          timer: 1000,
        });
      } else {
        if (nombreyapellido.length < 5 || nombreyapellido.indexOf(" ") == -1) {
          Swal.fire({
            position: "center",
            title: `INGRESE NOMBRE Y APELLIDO VÁLIDO`,
            icon: "error",
            showConfirmButton: false,
            timer: 1000,
          });
        } else {
          const dniExistente = invitadosList.find(
            (objeto) => objeto.dni === dni
          );

          if (dniExistente) {
            Swal.fire({
              position: "center",
              title: `DNI REPETIDO`,
              icon: "error",
              showConfirmButton: false,
              timer: 1000,
            });
            return; // No agregar el objeto si el DNI ya existe
          } else {
            if (capacidad <= 0) {
              Swal.fire({
                position: "center",
                title: `Solo puede agregar ${invitadosList.length} Participantes`,

                icon: "error",
                showConfirmButton: false,
                timer: 1000,
              });
            } else {
              if (categoriaEdad == "Adulto") {
                setCostoTotal(costoTotal + 5);
              }
              if (categoriaEdad == "Niño") {
                setCostoTotal(costoTotal + 3);
              }
              const newObject = {
                nombreyapellido: nombreyapellido,
                dni: dni,
                estado: editarReserva ? "No pagado" : "Por definir",
                categoriaEdad: categoriaEdad,
              };
              setInvitadosList((invitadosList) => [
                ...invitadosList,
                newObject,
              ]);
              setNombreyapellido("");
              setDni("");
              setCapacidad(capacidad - 1);
            }
          }
        }
      }
    }
  };
  //Funcion para Elimianar Reservas
  const eliminarReserva = async () => {
    Swal.fire({
      title: "BORRANDO RESERVA",
      text: `Se va a eliminar la reserva y todos los invitados`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteDoc(doc(db, `PARRILLAS`, idRegistroReservado));

        const querySnapshot = await getDocs(
          query(
            collection(db, `USUARIOS/${idRefUsuarioReservado}/RESERVAS`),
            where("idReserva", "==", idRegistroReservado)
          )
        );
        querySnapshot.forEach((doc) => {
          deleteDoc(doc.ref);
        });
        navigate("../panelCDA/zonaParrillas");
        Swal.fire("ELIMINADO", "Reserva eliminada con exito", "success");
      }
    });
  };
  //funcion para ver los datos de una reserva
  const verificarReservacion = async () => {
    const q = query(
      collection(db, "PARRILLAS"),
      where("fecha", "==", fecha),
      where("zona", "==", id)
    );
    const querySnapshot = await getDocs(q);
    setDatosCargados(true);
    setEditarReserva(false);

    querySnapshot.forEach(async (doc) => {
      //console.log("ENCONTRO AL USER EN FIREBASE");
      //console.log(doc.data());
      setEditarReserva(true);
      if (localStorage.getItem("nivelUsuario") == "ingeniero") {
        navigate("../panelUser/zonaParrillas");
        Swal.fire(
          "RESERVADO",
          "Esta zona ya se encuentra reservada. Seleccione otra por favor",
          "error"
        );
      } else {
        if (
          localStorage.getItem("nombreLocal") == "CIP" ||
          localStorage.getItem("nivelUsuario") == "admin"
        ) {
          setNombreUsuarioReservado(
            doc.data().nombre + " " + doc.data().apellidos
          );
          setCipUsuarioReservado(doc.data().cip);
          setIdRegistroReservado(doc.id);
          setIdRefRegistroReservado(doc.data().idRef);
          //console.log(doc.data().idRef)
          const colegiados = collection(db, `PARRILLAS/${doc.id}/INVITADOS`);
          const data = await getDocs(colegiados);

          setInvitadosList(
            data.docs.map((doc) => ({
              ...doc.data(),
              nombreyapellido: doc.data().nombre,
              id: doc.id,
            }))
          );
          setObservaciones(doc.data().observaciones);
        } else {
          if (localStorage.getItem("nivelUsuario") == "admin") {
            navigate("../panelAdmin");
          } else {
            navigate("../login");
          }
        }
      }
    });
  };

  //funcion pare eliminar invitados de la tabla
  const borrarInvitado = (idToRemove, catedad) => {
    const updatedList = invitadosList.filter((obj) => obj.dni !== idToRemove);

    if (catedad == "Adulto") {
      setCostoTotal(costoTotal - 5);
    }
    if (catedad == "Niño") {
      setCostoTotal(costoTotal - 3);
    }
    setInvitadosList(updatedList);
    setCapacidad(capacidad + 1);
  };

  const editarReservaParrilla = () => {
    MySwal.fire({
      title: `Editar reserva en ${
        elementos.find((elemento) => elemento.id === id).nombre
      } de la zona de parrilla el dia ${fechaFormateada}`,
      html: "Podrá completar su lista de 20 invitados el día del evento.",

      icon: "question",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Si, Editar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const invitados = collection(
          db,
          `PARRILLAS/${idRegistroReservado}/INVITADOS`
        );
        const q = query(invitados);
        const querySnapshot = await getDocs(q);

        //ELIMINAR LISTA DE INVITADOS ANTERIOR
        querySnapshot.forEach(async (iddoc) => {
          //console.log(iddoc.ref.id);
          const idDocumento = iddoc.ref.id.toString();
          await deleteDoc(
            doc(db, `PARRILLAS/${idRegistroReservado}/INVITADOS`, idDocumento)
          );
          //doc.ref.delete();
        });
        //AGREGAR LISTA DE INVITADOS NUEVA
        //await updateDoc(invitados, invitadosList);

        invitadosList.map(async (codigo) => {
          await addDoc(invitados, {
            nombre: codigo.nombreyapellido,
            dni: codigo.dni,
            estado: codigo.estado,
            categoriaEdad: codigo.categoriaEdad,
          });
          //console.log(codigo.dni);
        });

        let timerInterval;
        Swal.fire({
          title: "Editando datos...",
          html: "Quedan <b></b> segundos.",
          timer: 5000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
            const b = Swal.getHtmlContainer().querySelector("b");
            timerInterval = setInterval(() => {
              b.textContent = Swal.getTimerLeft() / 1000;
            }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            navigate(`../zonaparrilla/${idRegistroReservado}`);
            Swal.fire(
              "RESERVA EDITADA",
              "Se edito la reserva correctamente",
              "success"
            );
          }
        });
      }
    });
  };
  //funcion pare reservar o editar zona de parrilla
  const reservarZona = () => {
    console.log(invitadosList);
	let montorecibo=0;

    if (editarReserva) {
      editarReservaParrilla();
    } else {
      invitadosList.map((invitado) => {
        if (invitado.categoriaEdad == "Adulto") {
			montorecibo+=5
        } else if (invitado.categoriaEdad == "Niño") {
			montorecibo+=3

        }
      });
	  setMonto(montorecibo)
      console.log(montorecibo);

      if (localStorage.getItem("nombreLocal") == "CIP") {
        Swal.fire({
          title: `Reservar ${
            elementos.find((elemento) => elemento.id === id).nombre
          } el dia  ${fechaFormateada}`,
          html: "<span>Podrá completar su lista de 20 invitados el día del evento. </span>",
          inputLabel: "Ingrese alguna observacion extra ",
          input: "textarea",
          icon: "question",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Reservar",
          inputAttributes: {
            autocapitalize: "off",
            maxlength: 90, // Establecer la cantidad máxima de caracteres
          },
          inputValue: observaciones, // Establecer el valor inicial del campo de texto

          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            //setObservaciones(result.value);
            reservar();
          }
        });

        Swal.getInput().addEventListener("input", (event) => {
          setObservaciones(event.target.value);
          temporalObservaciones = event.target.value;
        });
        /*
        MySwal.fire({
          title: `Reservar ${
            elementos.find((elemento) => elemento.id === id).nombre
          } de la zona de parrilla el dia  ${fechaFormateada}`,
          html: "Podrá completar su lista de 20 invitados el día del evento.",
          icon: "question",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Reservar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            reservar();
          }
        });*/
      } else {
        Swal.fire({
          title: `Reservar ${
            elementos.find((elemento) => elemento.id === id).nombre
          } el dia  ${fechaFormateada}`,
          html: "<span>Podrá completar su lista de 20 invitados el día del evento. </span>",
          inputLabel: "Ingrese alguna observacion extra ",
          input: "textarea",
          icon: "question",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          showCancelButton: invitadosList.length > 0 ? true : false,

          confirmButtonText:
            invitadosList.length > 0 ? "REGISTRAR PAGO DESPUÉS" : "RESERVAR",

          cancelButtonText: "REGISTRAR PAGO AHORA",
          inputAttributes: {
            autocapitalize: "off",
          },
          inputValue: observaciones, // Establecer el valor inicial del campo de texto

          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            setObservaciones(result.value);

            reservar();
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            setMostrarPago(true);
          }
        });

        Swal.getInput().addEventListener("input", (event) => {
          setObservaciones(event.target.value);
          temporalObservaciones = event.target.value;
        });
        /*
        MySwal.fire({
          title: `Reservar ${
            elementos.find((elemento) => elemento.id === id).nombre
          } de la zona de parrilla el dia  ${fechaFormateada}`,
          html: "Puede agregar mas invitados después",
          icon: "question",
          showCancelButton: invitadosList.length > 0 ? true : false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText:
            invitadosList.length > 0 ? "REGISTRAR PAGO DESPUÉS" : "RESERVAR",
          cancelButtonText: "REGISTRAR PAGO AHORA",
        }).then(async (result) => {
          if (result.isConfirmed) {
            reservar();
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            setMostrarPago(true);
          }
        });*/
      }
    }
  };

  //Reservar zona

  const reservar = async () => {
    const parrillas = collection(db, `PARRILLAS`);
    let idReserva = "";
    await addDoc(parrillas, {
      nombre: nombreUsuario,
      apellidos: apellidoUsuario,
      zona: id,
      fecha: fecha,
      fechaReserva: new Date()
        .toLocaleString("es-ES", {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        })
        .toString(),

      cip: CIP,
      idRef:
        idRefBuscado != "0"
          ? idRefBuscado
          : localStorage.getItem("idDocumento"),
      estado: mostrarPago ? "Pagado" : "Pagar en el club",
      correlativo: correlativo == "" ? 0 : correlativo,
      nroSerie: nroSerie == "" ? 0 : nroSerie,
      monto: monto == "" ? 0 : monto,
      observaciones: temporalObservaciones,
    }).then(async (docRef) => {
      idReserva = docRef.id;
      setIdReservaParrilla(docRef.id);
      const entradaUsuario = collection(
        db,
        `USUARIOS/${
          idRefBuscado != "0"
            ? idRefBuscado
            : localStorage.getItem("idDocumento")
        }/RESERVAS`
      );
      await addDoc(entradaUsuario, {
        lugar: "ZONA DE PARRILLAS",
        zona: id,
        fecha: fecha,
        fechaReserva: new Date()
          .toLocaleString("es-ES", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })
          .toString(),
        idReserva: idReserva,
        estado: mostrarPago ? "Pagado" : "Pagar en el club",
        correlativo: correlativo == "" ? 0 : correlativo,
        nroSerie: nroSerie == "" ? 0 : nroSerie,
        monto: monto == "" ? 0 : monto,
        observaciones: temporalObservaciones,
      });

      const invitadosParrillas = collection(
        db,
        `PARRILLAS/${docRef.id}/INVITADOS`
      );
      invitadosList.map(async (codigo) => {
        await addDoc(invitadosParrillas, {
          nombre: codigo.nombreyapellido,
          dni: codigo.dni,
          estado: mostrarPago ? "Pagado" : "No pagado",
          categoriaEdad: codigo.categoriaEdad,
        });
      });
    });
    let timerInterval;
    Swal.fire({
      title: "Reservando...",
      html: "Quedan <b></b> segundos.",
      timer: 3000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        const b = Swal.getHtmlContainer().querySelector("b");
        timerInterval = setInterval(() => {
          b.textContent = Swal.getTimerLeft() / 1000;
        }, 100);
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        navigate(`../zonaparrilla/${idReserva}`);
        Swal.fire(
          "RESERVADO",
          "Se realizo la reserva correctamente",
          "success"
        );
      }
    });
  };

  // TODO PAGOS
  const validarFormulario = () => {
    if (correlativo == "" || monto == "" || nroSerie == "") {
      MySwal.fire("", "Llenar todos los campos", "error");
    } else {
      revisarPago();
    }
  };
  const volverAtras = () => {
    setMostrarPago(false);
  };
  const buscarPagosDiferidos = async () => {
    const cuponesList = collection(db, `TIPOSDEPAGOS`);
    const data = await getDocs(cuponesList);
    const pagosdiferidosList = data.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    setPagosDiferidos(pagosdiferidosList);
  };
  const validarmonto = async (monto) => {
    try {
      const res = await axios.get(
        `https://reservas.ciparequipa.org.pe/listaPagos/${correlativo}/${nroSerie}`
      );
      const miArreglo = [];
      let cantidadInvitados = 0;
      res.data.forEach(function (elementoRecibo) {
        pagosDiferidos.forEach(function (elementoPagosDiferidos) {
          //console.log("ENCONTRO - prueba " + elementoRecibo.ncan);

          if (elementoRecibo.vtipope == elementoPagosDiferidos.Codigo) {
            cantidadInvitados = parseInt(elementoRecibo.ncan);
          }
        });
      });
      if (cantidadInvitados >= 1) {
        if (cantidadInvitados != invitadosList.length) {
          MySwal.fire(
            "",
            "El número de invitados agregados no coincide con número de invitados pagados, verifique la lista de invitados",
            "warning"
          );
          setCorrelativo("");
          setNroSerie("");
        } else {
          reservar();
        }

        setpbVisible(false);
      } else {
        MySwal.fire("", "No se encontraron entrada(s) pagadas", "warning");
        setpbVisible(false);
        setCorrelativo("");
        setNroSerie("");
      }
    } catch (err) {
      MySwal.fire("", "DATOS DE PAGO INCORRECTO", "warning");
      setpbVisible(false);
      setCorrelativo("");
      setNroSerie("");
    }
  };
  const revisarPago = async (e) => {
    setpbVisible(true);

    try {
      const res = await axios.get(
        `https://reservas.ciparequipa.org.pe/pagos/${correlativo}/${nroSerie}/${monto}`
      );
      //console.log(res.data[0]);
      if (res.data[0].vnumdoc.includes(correlativo)) {
        setCorrelativo(res.data[0].vnumdoc);
        setNroSerie(res.data[0].vserdoc);
        //setMonto(res.data[0].nvaltot);
        let cipOperacion =
          cipBuscado == "" ? localStorage.getItem("idLocal") : cipBuscado;
        if (
          localStorage.getItem("nivelUsuario") == "admin" &&
          res.data[0].ncodcli != cipBuscado
        ) {
          MySwal.fire(
            "",
            "El recibo no coincide con el Codigo CIP " + cipOperacion,
            "warning"
          );
          setpbVisible(false);
        } else {
          if (
            localStorage.getItem("nivelUsuario") == "ingeniero" &&
            res.data[0].ncodcli != cipOperacion
          ) {
            MySwal.fire(
              "",
              "El recibo no coincide con el Codigo CIP " + cipOperacion,
              "warning"
            );
            setpbVisible(false);
          } else {
            obtenerAsientosRegistrados();
          }
        }
      } else {
        MySwal.fire("", "DATOS DE PAGO INCORRECTO", "warning");
        setCorrelativo("");
        setNroSerie("");
        setpbVisible(false);
      }
    } catch (err) {
      MySwal.fire("", "DATOS DE PAGO INCORRECTO", "warning");
      setCorrelativo("");
      setNroSerie("");
      setpbVisible(false);
    }
  };
  const obtenerAsientosRegistrados = async () => {
    const q = query(
      collection(
        db,
        `USUARIOS/${
          idRefBuscado != "0"
            ? idRefBuscado
            : localStorage.getItem("idDocumento")
        }/RESERVAS`
      ),
      where("lugar", "==", "ZONA DE PARRILLAS")
    );
    let flReciboUsado = false;
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      if (
        (doc.data().correlativo.toString().includes(correlativo) &&
          doc.data().nroSerie.toString().includes(nroSerie)) ||
        (correlativo.toString().includes(doc.data().correlativo) &&
          nroSerie.toString().includes(doc.data().nroSerie))
      ) {
        MySwal.fire("", "Este recibo ya fue usado ", "warning");
        setpbVisible(false);
        setCorrelativo("");
        setNroSerie("");
        flReciboUsado = true;
      }
    });
    if (flReciboUsado == false) {
      validarmonto(monto);
    }
  };
  //cerrar zonaparrillas
  const cerrar = () => {
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      navigate("../panelUser/zonaparrillas");
    } else {
      if (localStorage.getItem("nombreLocal") == "CIP") {
        navigate("../panelCDA/zonaparrillas");
      } else {
        if (localStorage.getItem("nivelUsuario") == "admin") {
          navigate("../panelAdmin/zonaparrillas");
        } else {
          navigate("../login");
        }
      }
    }
  };
  useEffect(() => {
    if (fecha) {
      const opcionesDeFormato = { day: "numeric", month: "long" };
      setFechaFormateada(
        new Date(fecha + "T17:00:00Z").toLocaleDateString(
          "es-ES",
          opcionesDeFormato
        )
      );
    } else {
    }
  }, [fecha]);

  useEffect(() => {
    buscarUsuarioCip();
    verificarReservacion();
    //TODO PAGOS
    buscarPagosDiferidos();
  }, []);

  const elementStyle = {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: "10px",
  };

  const inputStyle = {
    width: "100%",
  };
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      {!mostrarPago ? (
        <div className="panel">
          <NavBar
            titulo={`Agregar Invitados ${
              elementos.find((elemento) => elemento.id === id).nombre
            }`}
            nombre=""
            imagen="cerrar"
            logoTitulo="zonaparrillas"
            cerrar={cerrar}
          ></NavBar>
          <div className="ZP-agregar-label">
            <h1
              className="cd"
              style={{
                alignContent: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              Fecha: {fechaFormateada}
            </h1>
            <h1
              className="cd"
              style={{
                alignContent: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              Capacidad : {capacidad} participantes
            </h1>
          </div>
          {editarReserva ? (
            <div className="ZP-agregar-label">
              <h1
                className="cd"
                style={{
                  alignContent: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                Nombre: {nombreUsuarioReservado}
              </h1>
              <h1
                className="cd"
                style={{
                  alignContent: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                CIP : {cipUsuarioReservado}
              </h1>
            </div>
          ) : null}
          {localStorage.getItem("nivelUsuario") != "ingeniero" &&
          editarReserva == true ? (
            <div style={{ paddingLeft: "48px", paddingTop: "20px" }}>
              <Button
                style={{ marginBottom: "10px" }}
                variant="contained"
                color="error"
                onClick={() => {
                  eliminarReserva();
                }}
              >
                Eliminar reserva
              </Button>
            </div>
          ) : null}
          {localStorage.getItem("nivelUsuario") == "admin" &&
          editarReserva == false ? (
            <div className="ZP-agregar">
              <div
                style={{
                  display: "inline-block",
                  border: "1px solid",
                  padding: "24px",
                }}
              >
                <div className="ZP-agregar">
                  <h1
                    className="cd"
                    style={{
                      alignContent: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      paddingTop: "0px",
                    }}
                  >
                    Buscar Ingeniero
                  </h1>
                </div>

                <div className="ZP-agregar">
                  <TextField
                    sx={{ width: 300 }}
                    label="CIP del Ingeniero"
                    variant="standard"
                    type="number"
                    value={cipBuscado}
                    onChange={(e) => setCipBuscado(e.target.value)}
                  />
                  <span className="separator">&nbsp;&nbsp;&nbsp;</span>
                  {nombreyapellidovisible ? (
                    <TextField
                      sx={{ width: 300 }}
                      label="Nombre y apellido"
                      variant="standard"
                      value={nombreIngenieroBuscado}
                      InputProps={{ readOnly: true }}
                      onChange={(e) =>
                        setNombreIngenieroBuscado(e.target.value)
                      }
                    />
                  ) : null}
                  <span className="separator">&nbsp;&nbsp;&nbsp;</span>

                  <div style={{ width: "300px", display: "flex" }}>
                    <input
                      type="submit"
                      value="Buscar CIP"
                      className="fau-btnAgregarComunicado"
                      onClick={() => {
                        buscarCodigoCip();
                      }}
                    />
                  </div>
                </div>
                {pbVisibleBusqueda ? (
                  <LinearProgress
                    color="success"
                    style={{ marginTop: 20, textAlign: "center" }}
                  />
                ) : null}
              </div>
              {pbVisibleBusqueda ? (
                <LinearProgress
                  color="success"
                  style={{ marginBottom: 20, textAlign: "center" }}
                />
              ) : null}
            </div>
          ) : null}

          <span className="separator">&nbsp;&nbsp;&nbsp;</span>

          <div className="ZP-agregar">
            <div
              style={{
                display: "inline-block",
                border: "1px solid",
                padding: "24px",
              }}
            >
              <div className="ZP-agregar">
                <h1
                  className="cd"
                  style={{
                    alignContent: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    paddingTop: "0px",
                  }}
                >
                  AGREGAR INVITADOS
                </h1>
              </div>
              <div className="ZP-agregar">
                <TextField
                  sx={{ width: 300 }}
                  label="Nombre y Apellido del invitado"
                  variant="standard"
                  value={nombreyapellido}
                  onChange={(e) => setNombreyapellido(e.target.value)}
                />
                <span className="separator">&nbsp;&nbsp;&nbsp;</span>

                <TextField
                  sx={{ width: 300 }}
                  type="number"
                  label="DNI del invitado"
                  variant="standard"
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                />
                <span className="separator">&nbsp;&nbsp;&nbsp;</span>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth variant="standard">
                    <InputLabel
                      variant="standard"
                      htmlFor="uncontrolled-native"
                    >
                      Categoría de edad
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={categoriaEdad}
                      label="categoriaEdad"
                      onChange={(e) => setCategoriaEdad(e.target.value)}
                    >
                      <MenuItem value={"Adulto"}>Adulto</MenuItem>
                      <MenuItem value={"Niño"}>Niño</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <span className="separator">&nbsp;&nbsp;&nbsp;</span>

                <div style={{ width: "300px", display: "flex" }}>
                  <input
                    type="submit"
                    value="Agregar invitado"
                    className="fau-btnAgregarComunicado"
                    onClick={() => {
                      agregarInvitado();
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {invitadosList.length > 0 ? (
            <div className="ZP-tabla">
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        <b>NOMBRE Y APELLIDO</b>
                      </TableCell>
                      <TableCell align="center">
                        <b>DNI</b>
                      </TableCell>
                      <TableCell align="center">
                        <b>Categoria de edad</b>
                      </TableCell>
                      <TableCell align="center">
                        <b>ESTADO DE PAGO</b>
                      </TableCell>
                      <TableCell align="center">
                        <b>BORRAR</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invitadosList.map((row, index) => (
                      <TableRow
                        key={row.dni}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="center">
                          {row.nombreyapellido}
                        </TableCell>
                        <TableCell align="center">{row.dni}</TableCell>
                        <TableCell align="center">
                          {row.categoriaEdad}
                        </TableCell>
                        <TableCell align="center">{row.estado}</TableCell>

                        <TableCell align="center">
                          <Button
                            variant="contained"
                            color="error"
                            onClick={() => {
                              borrarInvitado(row.dni, row.categoriaEdad);
                              //borrarTicket(row.dni);
                              //buscarIdUsuario(row.id, row.CIP, row.asientos);
                              //borrarTicketUsuario(row.asientos)
                            }}
                          >
                            BORRAR
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : null}

          <div
            className="footer"
            onClick={() => {
              reservarZona();
            }}
          >
            <strong className="centered-button">
              {editarReserva != true ? "RESERVAR" : "EDITAR"}
            </strong>
            <strong className="centered-button">
              {editarReserva != true ? `S/.${costoTotal}` : null}
            </strong>
          </div>
        </div>
      ) : (
        <Fragment>
          <NavBar
            titulo="Ingresar recibo de pago"
            imagen="cerrar"
            logoTitulo="usuarios"
            cerrar={cerrar}
          ></NavBar>

          <div className="fau-agregarUsuarios">
            <div className="fau-card">
              <div className="fau-formNumber">
                <Box sx={{ width: 350 }}>
                  <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                    <ContactMailRoundedIcon
                      sx={{ color: "action.active", mr: 1, my: 0.5 }}
                    />
                    <TextField
                      sx={{ width: 350 }}
                      label="Numero de Serie"
                      variant="standard"
                      type="number"
                      value={nroSerie}
                      onChange={(e) => setNroSerie(e.target.value)}
                    />
                  </Box>
                </Box>
              </div>

              <div className="fau-formNumber">
                <Box sx={{ width: 350 }}>
                  <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                    <PasswordRoundedIcon
                      sx={{ color: "action.active", mr: 1, my: 0.5 }}
                    />
                    <TextField
                      sx={{ width: 350 }}
                      label="Correlativo"
                      value={correlativo}
                      variant="standard"
                      onChange={(e) => setCorrelativo(e.target.value)}
                    />
                  </Box>
                </Box>
              </div>
              <div className="fau-formNumber">
                <Box sx={{ width: 350 }}>
                  <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                    <MonetizationOnIcon
                      sx={{ color: "action.active", mr: 1, my: 0.5 }}
                    />
                    <TextField
                      sx={{ width: 350 }}
                      label="Monto"
                      value={monto}
                      variant="standard"
                      disabled
                    />
                  </Box>
                </Box>
              </div>
              <div
                style={{
                  width: "180px",
                  textAlign: "center",
                  alignItems: "center",
                  placeContent: "center",
                }}
              ></div>

              <div className="fau-formNumber">
                <div className="fau-addUser">
                  {pbVisible ? (
                    <LinearProgress
                      color="success"
                      style={{ marginBottom: 20 }}
                    />
                  ) : null}

                  <input
                    type="submit"
                    value="Buscar Recibo"
                    className="fau-btnAgregarComunicado"
                    onClick={validarFormulario}
                  />
                  <span className="separator">&nbsp;&nbsp;&nbsp;</span>

                  <input
                    type="submit"
                    value="Volver Atras"
                    className="fau-btnAgregarComunicado"
                    onClick={volverAtras}
                  />
                </div>
              </div>
            </div>
            <div className="fau-card">
              <img
                id="imagenTienda"
                src={boleta}
                alt="logo-titulo"
                className="imagenEmpresa"
              />
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
}

export default RegistrarZonaParrilla;
